import React from 'react';
import styled from 'styled-components';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import { useLanguage } from '../i18n/LanguageContext';

const PageWrapper = styled.main`
  padding: 120px 20px 80px;
  background: linear-gradient(180deg, rgba(247, 248, 252, 1) 0%, rgba(234, 239, 252, 1) 100%);

  @media (max-width: 768px) {
    padding: 100px 18px 70px;
  }

  @media (max-width: 480px) {
    padding: 86px 16px 60px;
  }
`;

const ContentContainer = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 48px;
  align-items: center;

  @media (max-width: 768px) {
    gap: 32px;
  }
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;

  @media (max-width: 768px) {
    text-align: center;
    align-items: center;
    gap: 20px;
  }
`;

const PageTag = styled.span`
  width: fit-content;
  padding: 6px 16px;
  border-radius: 999px;
  background: rgba(12, 77, 162, 0.16);
  color: var(--primary);
  letter-spacing: 0.32em;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;

  @media (max-width: 768px) {
    align-self: center;
  }
`;

const PageTitle = styled.h1`
  margin: 0;
  font-size: clamp(2.6rem, 4vw, 3.6rem);
  color: var(--secondary);
  line-height: 1.1;

  @media (max-width: 768px) {
    line-height: 1.2;
  }
`;

const IntroText = styled.p`
  margin: 0;
  color: var(--text-muted);
  font-size: 1.06rem;
  line-height: 1.85;

  @media (max-width: 768px) {
    font-size: 1.02rem;
  }
`;

const FounderQuote = styled.blockquote`
  margin: 0;
  padding: 24px 28px;
  border-left: 4px solid var(--primary);
  border-radius: var(--radius-md);
  background: rgba(12, 77, 162, 0.08);
  color: var(--secondary);
  font-size: 1.02rem;
  line-height: 1.7;
  font-style: italic;

  @media (max-width: 768px) {
    padding: 22px 24px;
    text-align: left;
  }
`;

const Signature = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-weight: 600;
  color: var(--secondary);
`;

const Role = styled.span`
  font-size: 0.95rem;
  color: var(--text-muted);
  font-weight: 500;
`;


const BioSection = styled.section`
  padding: 90px 20px;
  background: #ffffff;

  @media (max-width: 768px) {
    padding: 74px 18px;
  }

  @media (max-width: 480px) {
    padding: 64px 16px;
  }
`;

const BioContainer = styled.div`
  max-width: 920px;
  margin: 0 auto;
  display: grid;
  gap: 20px;

  @media (max-width: 768px) {
    gap: 18px;
  }
`;

const BioTitle = styled.h2`
  margin: 0;
  font-size: clamp(2rem, 3vw, 2.6rem);
  color: var(--secondary);
`;

const BioText = styled.p`
  margin: 0;
  color: var(--text-muted);
  font-size: 1.02rem;
  line-height: 1.85;
`;

const CareersPage = () => {
  const { t } = useLanguage();
  const visionParagraphs = t('pages.careers.visionParagraphs');

  return (
    <>
      <PageWrapper>
        <ContentContainer>
          <TextBlock>
            <PageTag>{t('pages.careers.tag')}</PageTag>
            <PageTitle>{t('pages.careers.title')}</PageTitle>
            <IntroText>{t('pages.careers.intro')}</IntroText>
            <FounderQuote>{t('pages.careers.quote')}</FounderQuote>
            <Signature>
              Hicham El Hammadi
              <Role>{t('pages.careers.signatureRole')}</Role>
            </Signature>
          </TextBlock>
        </ContentContainer>
      </PageWrapper>

      <BioSection>
        <BioContainer>
          <BioTitle>{t('pages.careers.visionTitle')}</BioTitle>
          {visionParagraphs.map((paragraph) => (
            <BioText key={paragraph}>{paragraph}</BioText>
          ))}
        </BioContainer>
      </BioSection>

      <CTASection />
      <Footer />
    </>
  );
};

export default CareersPage;
